import React from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { ResourceCardV2Skeleton } from "@/modules/hub/features/ResourceLibraryV2/components/ResourceCardV2/ResourceCardV2Skeleton";

// Initial-load skeleton for News V2. Mirrors the real layout: the sort and
// favorites toolbar followed by a grid of V2 resource cards.
export const NewsV2Skeleton: React.FC = () => {
  return (
    <MainPageWrapper
      subtitle="Latest updates and insights from across the trades"
      title="News"
    >
      <div className="space-y-6">
        {/* Featured carousel placeholder (matches FeaturedCarouselV2 loading state) */}
        <div className="aspect-video sm:aspect-auto sm:h-52 rounded-xl border border-gray-200 dark:border-slate-700 bg-gray-100 dark:bg-slate-800 animate-pulse" />

        {/* Sort + favorites toolbar */}
        <div className="flex bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl px-3 py-1.5 justify-between items-center animate-pulse">
          <div className="flex items-center gap-4">
            <div className="h-4 w-36 bg-gray-200 dark:bg-gray-700 rounded" />
            <div className="h-4 w-28 bg-gray-200 dark:bg-gray-700 rounded" />
          </div>
          <div className="h-9 w-[180px] bg-gray-200 dark:bg-gray-700 rounded-md" />
        </div>

        {/* Card grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <ResourceCardV2Skeleton key={i} showTradeBadge={false} />
          ))}
        </div>
      </div>
    </MainPageWrapper>
  );
};